import toast from "react-hot-toast";
import * as api from "../Api";
import io from "socket.io-client";
const socket = io();
export const getApprovedClaims = () => async (dispatch) => {
  try {
    const { data } = await api.getApprovedClaims();
    dispatch({ type: "GET_ALL_APPROVED_CLAIMS", payload: data });
  } catch (error) {}
};

export const printBranchClaim = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving changes...");
    await api.approveBranchClaim(id, postData);
    dispatch({ type: "PRINT_BRANCH_CLAIM", payload: id });
    toast.remove(updatingId);
    toast.success("Changes saved successfully");
    socket.emit("submitClaim", {});
  } catch (error) {
    toast.remove(updatingId);
    toast.error(error.message);
  }
};
